<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ city.id ? $t('city.form.editTitle') : $t('city.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('city.form.nameLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="city.name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="EmailDomain">{{ $t('city.form.ufLabel') }}</label>
                      <v-select
                        :options="ufs"
                        :reduce="(ufs) => ufs.id"
                        :label="'name'"
                        v-model="city.uf_id"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('city.form.ufCodeLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="city.uf_code"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('city.form.codeLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="city.code"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('common.status') }}:
                      </label>
                      <select v-model="city.status" class="form-control">
                        <option :value="1">{{ $t('common.active') }}</option>
                        <option :value="0">{{ $t('common.inactive') }}</option>
                      </select>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t('city.form.requiredFields') }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/cities" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      {{ $t('common.save') }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      city: {
        name: "",
        uf_id: "",
        uf_code: "",
        code: "",
        status: "1",
      },
      ufs: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "cities";

      if (self.city.id) {
        self.city._method = "PUT";
        api += "/" + self.city.id;
      }

      self.$loading(true);

      axios
        .post(api, self.city)
        .then((response) => {
          self.$message(
            self.$t('city.messages.successTitle'),
            self.$t('city.messages.saveSuccess'),
            "success"
          );
          self.$loading(false);
          this.$router.push("/cities");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getUfs: function () {
      const self = this;
      let api = self.$store.state.api + "ufs?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.ufs = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCity: function (id) {
      const self = this;
      const api = self.$store.state.api + "cities/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.city = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getUfs();

    let id = self.$route.params.id;
    if (id) {
      self.getCity(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>